/* tslint:disable */
/* eslint-disable */
/**
 * PanKanapka
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    InlineResponse403,
    InlineResponse403FromJSON,
    InlineResponse403ToJSON,
    OrderMenu,
    OrderMenuFromJSON,
    OrderMenuToJSON,
    OrderMenuDataFrame,
    OrderMenuDataFrameFromJSON,
    OrderMenuDataFrameToJSON,
} from '../models';

export interface ApiOrderMenusGetRequest {
    relations?: string;
    deleted?: boolean;
    filtering?: string;
    offset?: number;
    limit?: number;
    order?: string;
}

export interface ApiOrderMenusIdDeleteRequest {
    id: number;
}

export interface ApiOrderMenusIdGetRequest {
    id: number;
    relations?: string;
    deleted?: boolean;
}

export interface ApiOrderMenusPostRequest {
    relations?: string;
    deleted?: boolean;
    orderMenu?: OrderMenu;
}

/**
 * no description
 */
export class OrderMenuApi extends runtime.BaseAPI {

    /**
     * Get list of OrderMenu
     */
    async apiOrderMenusGetRaw(requestParameters: ApiOrderMenusGetRequest): Promise<runtime.ApiResponse<OrderMenuDataFrame>> {
        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.relations !== undefined) {
            queryParameters['relations'] = requestParameters.relations;
        }

        if (requestParameters.deleted !== undefined) {
            queryParameters['deleted'] = requestParameters.deleted;
        }

        if (requestParameters.filtering !== undefined) {
            queryParameters['filtering'] = requestParameters.filtering;
        }

        if (requestParameters.offset !== undefined) {
            queryParameters['offset'] = requestParameters.offset;
        }

        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }

        if (requestParameters.order !== undefined) {
            queryParameters['order'] = requestParameters.order;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearerAuth", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/orderMenus`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => OrderMenuDataFrameFromJSON(jsonValue));
    }

    /**
     * Get list of OrderMenu
     */
    async apiOrderMenusGet(relations?: string, deleted?: boolean, filtering?: string, offset?: number, limit?: number, order?: string): Promise<OrderMenuDataFrame> {
        const response = await this.apiOrderMenusGetRaw({ relations: relations, deleted: deleted, filtering: filtering, offset: offset, limit: limit, order: order });
        return await response.value();
    }

    /**
     * Remove entity of OrderMenu
     */
    async apiOrderMenusIdDeleteRaw(requestParameters: ApiOrderMenusIdDeleteRequest): Promise<runtime.ApiResponse<OrderMenu>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling apiOrderMenusIdDelete.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearerAuth", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/orderMenus/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => OrderMenuFromJSON(jsonValue));
    }

    /**
     * Remove entity of OrderMenu
     */
    async apiOrderMenusIdDelete(id: number): Promise<OrderMenu> {
        const response = await this.apiOrderMenusIdDeleteRaw({ id: id });
        return await response.value();
    }

    /**
     * Get entity of OrderMenu
     */
    async apiOrderMenusIdGetRaw(requestParameters: ApiOrderMenusIdGetRequest): Promise<runtime.ApiResponse<OrderMenu>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling apiOrderMenusIdGet.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.relations !== undefined) {
            queryParameters['relations'] = requestParameters.relations;
        }

        if (requestParameters.deleted !== undefined) {
            queryParameters['deleted'] = requestParameters.deleted;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearerAuth", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/orderMenus/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => OrderMenuFromJSON(jsonValue));
    }

    /**
     * Get entity of OrderMenu
     */
    async apiOrderMenusIdGet(id: number, relations?: string, deleted?: boolean): Promise<OrderMenu> {
        const response = await this.apiOrderMenusIdGetRaw({ id: id, relations: relations, deleted: deleted });
        return await response.value();
    }

    /**
     * Create or update entity of OrderMenu (if id defined)
     */
    async apiOrderMenusPostRaw(requestParameters: ApiOrderMenusPostRequest): Promise<runtime.ApiResponse<OrderMenu>> {
        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.relations !== undefined) {
            queryParameters['relations'] = requestParameters.relations;
        }

        if (requestParameters.deleted !== undefined) {
            queryParameters['deleted'] = requestParameters.deleted;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearerAuth", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/orderMenus`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: OrderMenuToJSON(requestParameters.orderMenu),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => OrderMenuFromJSON(jsonValue));
    }

    /**
     * Create or update entity of OrderMenu (if id defined)
     */
    async apiOrderMenusPost(relations?: string, deleted?: boolean, orderMenu?: OrderMenu): Promise<OrderMenu> {
        const response = await this.apiOrderMenusPostRaw({ relations: relations, deleted: deleted, orderMenu: orderMenu });
        return await response.value();
    }

}
